const slotsList = (state = null, action) => {
  if (action.type === "SET_SLOTS_LIST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_SLOTS_LIST": {
  //     return action.payload;
  //   }
  
  //   default: {
  //     return state;
  //   }
  // }
};

export default slotsList;
